import Vue from 'vue'
import Vuex from 'vuex'

// import * as token from '../utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    photo: '',
    campusId: null
  },
  mutations: {
    setCampusId(state, id) {
      state.campusId = id
    }
  },
  actions: {
  }
})
